import { createFileRoute } from '@tanstack/react-router';

import { LandingConcept } from '#features/landing/components/LandingConcept';

export const Route = createFileRoute('/{-$locale}/_layout/preview/landing-arena')({
  staticData: { rendersOwnFooter: true },
  component: LandingArenaPreview,
  ssr: false,
});

function LandingArenaPreview() {
  const { locale } = Route.useParams();
  return <LandingConcept variant="arena" language={locale === 'ru' ? 'ru' : 'en'} />;
}
